import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UtilityCommon } from '../../../../common/utils/utility-common';
import { OperationsService } from '../../../../core/services/operations.service';
import { UserManager } from '../../../../core/services/user-manager';
import { GruppoTerritoriale } from '../../../models/gruppo-territoriale';
import { GruppoVisibilita } from '../../../models/gruppo-visibilita';
import { Utente } from '../../../models/utente';
import { UtenteLoggato } from '../../../models/utente-loggato';
import { FilterSearchPipe } from '../../../pipes/filter-search.pipe';
import { FascicoloFull } from 'src/app/common/models/fascicolo/fascicolo-full';

@Component({
  selector: '[assegnazione_competenza_form]',
  styleUrls: ['./assegnazione-competenza-form.component.css'],
  templateUrl: 'assegnazione-competenza-form.component.html'
})
export class AssegnazioneCompetenzaFormComponent implements OnInit {
  gruppiTerritoriali: GruppoTerritoriale[];
  gruppiByPrefix: GruppoTerritoriale[];
  gruppiTerritorialiSelected: GruppoTerritoriale[];
  gruppiCompetenti: GruppoVisibilita[];
  listaUtenti: Utente[];
  listaCompletaUtenti: Utente[];
  disabledGroupId: string;
  allGroupsFlag: boolean = false;
  gruppoCompetente: GruppoVisibilita;
  nomiGruppiCivili: GruppoTerritoriale[] = [
    {
      id: "GRP_TR_Servizio|Difesa|Giuridica|Contenzioso|Civile|e|Penale",
      label: "Servizio Difesa Giuridica Contenzioso Civile e Penale",
      nomeGruppo: "Servizio Difesa Giuridica Contenzioso Civile e Penale",
    },
    {
      id: "GRP_TR_Servizio|Difesa|Giuridica|Patrimonio",
      label: "Servizio Difesa Giuridica Patrimonio",
      nomeGruppo: "Servizio Difesa Giuridica Patrimonio",
    },
    {
      id: "GRP_TR_Servizio|Difesa|Giuridica|Civile",
      label: "Servizio Difesa Giuridica Civile",
      nomeGruppo: "Servizio Difesa Giuridica Civile",
    },
  ];
  isGruppoCivile: boolean = false;
  hideGroupAssegnazioneCompetenza =UtilityCommon.hideGroupAssegnazioneCompetenza;

  @Input()
  wizard: boolean;

  @Input()
  idFascicolo: string;

  @Input()
  fascicolo: FascicoloFull;

  @Input()
  utenteCompetente: Utente;

  @Input()
  tipoFascicolo: any;

  @Output()
  gruppiCompetentiOutput = new EventEmitter();

  @Output()
  onSelectUser = new EventEmitter();

  @Output()
  onSelectGroup = new EventEmitter();

  @Output()
  onRetrieveGruppi = new EventEmitter();

  @Output()
  gruopFromLoggedUser = new EventEmitter();

  constructor(private operationsServices: OperationsService, private filterpipe: FilterSearchPipe, private userManager: UserManager) {}

  ngOnInit() {
    this.getGruppiTerritoriali();
     if (this.wizard) {
      let user = new Utente();
      this.selectingUser(user);
    }
    if (!this.wizard) {
      this.setUtenteCompetente();
    }
  }

  setUtenteCompetente() {
    this.operationsServices.getUtenteAssegnatario(this.idFascicolo).subscribe(response => {
      this.utenteCompetente = response[0];
      this.selectingUser(this.utenteCompetente);
    });
  }

  getGruppiTerritoriali() {
    this.operationsServices.getGruppiTerritoriali().subscribe(response => {
      this.gruppiTerritoriali = response;
      this.getGruppiTerritorialiCompetenti();
    });
  }

  setGruppiCompetenti(gruppi: GruppoVisibilita[]) {
    this.gruppiCompetenti = gruppi;
    this.gruppiCompetentiOutput.emit(gruppi);
    this.setGruppoDefault(gruppi);
    this.onRetrieveGruppi.emit(false);
  }


  setGruppoDefault(gruppi) {
    this.gruopFromLoggedUser.emit( gruppi[0])
    this.gruppiTerritorialiSelected = new Array<GruppoTerritoriale>();
    this.allGroupsFlag = false;
    let gruppoTerritorialeArray = new Array<GruppoTerritoriale>();
    for (let gruppoCompetente of gruppi) {
      if (gruppoCompetente.competenze) {
        let disabledGroup = new GruppoTerritoriale();
        disabledGroup.id = gruppoCompetente.id;
        disabledGroup.nomeGruppo = gruppoCompetente.nomeGruppo;
        gruppoTerritorialeArray.push(disabledGroup);
        this.isGruppoOrganizzativoCivile(gruppoCompetente);
        if (this.isGruppoCivile) {
          this.gruppiTerritoriali
            .filter((elemento) =>
              this.nomiGruppiCivili.some(el => el.id === elemento.id))
            .map((x) => (x.active = true));
        }
        this.operationsServices
          .getAssegnatari(gruppoTerritorialeArray, this.fascicolo)
          .subscribe((response) => this.setUtenti(response));
        this.gruppoCompetente = gruppoCompetente;
      }
      let defaultGroup = new GruppoTerritoriale();
      defaultGroup.id = gruppoCompetente.id;
      defaultGroup.nomeGruppo = gruppoCompetente.nomeGruppo;
      this.refreshSelectedList(defaultGroup);
    }
    if (this.wizard) {
      let user = new Utente();
      this.selectingUser(user);
    }
    if (!this.wizard) {
      this.selectingUser(this.utenteCompetente);
    }
  }

  setUtenti(utenti) {
    this.listaUtenti = utenti;
    this.listaCompletaUtenti = utenti;
    let utenteLoggato: UtenteLoggato = this.userManager.getUser();
    let index = this.listaCompletaUtenti.findIndex(
      (utente) => utente.username === utenteLoggato.username
    );
    if (this.listaCompletaUtenti.length == 0) {
      this.onSelectUser.emit(null);
    }
    if (index != -1) {
      this.utenteCompetente = this.listaCompletaUtenti[index];
      this.onSelectUser.emit(this.utenteCompetente);
    }
    if (this.isGruppoCivile && index == -1) {
      this.utenteCompetente = null;
      this.onSelectUser.emit(null);
    }
  }

  getGruppiTerritorialiCompetenti() {
    this.operationsServices
      .getGruppiTerritorialiCompetenti(this.idFascicolo)
      .subscribe((response) => this.setGruppiCompetenti(response));
  }

  onSelectOneGroup(gruppo: GruppoTerritoriale) {
    this.gruppiTerritorialiSelected = new Array<GruppoTerritoriale>();
    this.refreshSelectedList(gruppo);
  }

  onSelectAllGroups() {
    this.allGroupsFlag = !this.allGroupsFlag;
    if (!this.allGroupsFlag) {
      this.setGruppoDefault(this.gruppiCompetenti);
    } else {
      if (this.allGroupsFlag) {
        this.gruppiTerritorialiSelected = new Array<GruppoTerritoriale>();
        this.gruppiTerritorialiSelected = this.gruppiTerritoriali;
        this.onSelectGroup.emit(this.gruppiTerritorialiSelected);
      }
    }
  }

  refreshSelectedList(gruppo: GruppoTerritoriale) {
    this.gruppiTerritorialiSelected.push(gruppo);
    this.onSelectGroup.emit(this.gruppiTerritorialiSelected);
  }

  onSelectMultipleGroups($event, id) {
    this.gruppiTerritorialiSelected = new Array<GruppoVisibilita>();
      for (let input of $event.srcElement.form) {
        if (input.checked && this.isGruppoCivile) {
          for (let gruppo of this.gruppiTerritoriali) {
            if (gruppo.id === input.id && gruppo.id == id) {
              this.refreshSelectedList(gruppo);
            }
          }
        }
        else if(!this.isGruppoCivile) {
          for (let gruppo of this.gruppiTerritoriali) {
            if (gruppo.id === input.id ) {
              this.refreshSelectedList(gruppo);
            }
          }
        }
      }
    if (this.isGruppoCivile) {
     this.getAssegnatariCivili();
    }
    this.allGroupsFlag = this.gruppiTerritorialiSelected.length == this.gruppiTerritoriali.length;
  }

  selectingUser(user: Utente) {
    this.onSelectUser.emit(user);
  }

  isPresente(idGruppo): boolean {
    let retVal = false;
    let ind = this.gruppiTerritorialiSelected.findIndex((g) => g.id === idGruppo);
    if (ind >= 0) {
      retVal = true;
    }
    return retVal;
  }

  isCompetente(idGruppo): boolean {
    let retVal = false;
   if(!this.isGruppoCivile){
    let ind = this.gruppiCompetenti.findIndex((g) => g.id === idGruppo);
    if (ind >= 0) {
      if (this.gruppiCompetenti[ind].competenze) {
        retVal = true;
      }
    }}
    return retVal;
  }

  isGruppoOrganizzativoCivile(gruppoCompetente: GruppoVisibilita) {
    this.isGruppoCivile = false;
    if (this.nomiGruppiCivili.some(item => item.id === gruppoCompetente.id)) {
      this.isGruppoCivile = true;
    }
  }

  getAssegnatariCivili() {
    let gruppiTerritorialeAdapted = {
      id: this.gruppiTerritorialiSelected[0].id,
      label: this.gruppiTerritorialiSelected[0].label,
      nomeGruppo: this.gruppiTerritorialiSelected[0].nomeGruppo,
    };
    this.gruppoCompetente.nomeGruppo = gruppiTerritorialeAdapted.nomeGruppo;
    let gruppiTerritoriali = new Array<GruppoTerritoriale>();
    gruppiTerritoriali.push(gruppiTerritorialeAdapted);
    this.onSelectGroup.emit(gruppiTerritoriali);
    this.operationsServices
      .getAssegnatari(gruppiTerritoriali, this.fascicolo)
      .subscribe((response) => this.setUtenti(response));
  }

  filterUtenti(event) {
    if (event.srcElement.value !== "") {
     this.listaUtenti = this.filterpipe.transform(this.listaUtenti, event.srcElement.value, 'label', null);
    } else {
      this.listaUtenti = this.listaCompletaUtenti;
    }
  }

}
